import React from 'react';

import OrangeHoverCard from './OrangeHoverCard';

const OrangeHoverCards = ({ benefits }) => {
  if (!benefits?.length) {
    return <></>;
  }

  return (
    <div className="rs-services style3 services-home6-style pt-20 pb-20 md-pt-15 md-pb-15">
      <div className="container">
        <div className="row">
          {benefits.map(({ title, text, icon }, i) => (
            <OrangeHoverCard key={i} title={title} text={text} icon={icon} number={i + 1} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default OrangeHoverCards;
